module.exports = __webpack_public_path__ + "media/img/vca/nome1-d1ffeac9ac8f066385f20821c9f5bfc1.png";